import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import * as Data from "../../../Data";
import * as Dati from "../../../Dati";
import * as DatiFide from "../../../DatiFide";
import * as Glob from "../../../Globale";
import useReducerOnChange from "../../../hooks/ReducerOnChange";
import ChiamaWeb, { CChiamaWebParametri } from "../../../ChiamaWeb";
import { Trad } from "../../../components/";
import { _ButtonAPI, _ChangeStatusButtons, _Derogation, _ExposureLimitFormContent } from "..";
import useDerogation from "../../hooks/Derogation";
import { IRouteParam } from "../../pages/ExposureLimit";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface IExposureLimitFormProps {
    ID_Anag: number;
    ID_FideAffidamento: number;
}

export const _ExposureLimitForm: React.FC<IExposureLimitFormProps> = ({ ID_Anag, ID_FideAffidamento }) => {
    const history = useHistory();
    const DataRiferimento = useParams<IRouteParam>().DataRiferimento || Data.DataValoreCompleta(new Date());
    const { ShowDialog } = useContext(AlertDialogContext);
    const editingRights = Glob.AzioneAbilitata("FideAffidamentoController", Glob.Scrittura);
    const initialFormData = {
        ...new DatiFide.CDatiFideAffidamento(),
        ID_TipoFideAffidamento: Glob.Tipi_FA_Affidamento,
        ID_AnagA: ID_Anag,
        ID_AnagDa: Glob.GetSessione().ID_Anag
    };

    const [FormData, setFormData] = useReducerOnChange<DatiFide.CDatiFideAffidamento>(initialFormData);
    const [Types, setTypes] = useState({});
    const [Limits, setLimits] = useState<Dati.Dictionary<number>>({});
    const [LimitsSOA, setLimitsSOA] = useState<Dati.Dictionary<number>>({});
    const { DerogationFieldsList, OnChangeDerogation } = useDerogation();
    const [CurrentStatus, setCurrentStatus] = useState("");

    const _LimitiDeroga: Dati.Dictionary<any> = {};

    useEffect(() => {
        GetData();
    }, [useParams<IRouteParam>().ID_FideAffidamento, useParams<IRouteParam>().DataRiferimento]);

    useEffect(() => {
        GetLimits();
    }, [useParams<IRouteParam>().ID_FideAffidamento]);

    useEffect(() => {
        GetLimitsSOA();
    }, []);

    useEffect(() => {
        SetLimitsOnLocalVariables();
        SetLimitsOnLimitsSOA();
    }, [FormData.ID_TipoFideAffidamento, LimitsSOA, FormData.ID_TipoSOA]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fideaffidamento/seleziona?ID_FideAffidamento=${ID_FideAffidamento}&DataRiferimento=${DataRiferimento}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: DatiFide.CRisAPIDatoTipi_FideAffidamento) => {
        if (ID_FideAffidamento && data.Dato.ID_FideAffidamento == 0) {
            history.push(`/anagrafica/${ID_Anag}/fideaffidamento/0`);
        } else {
            if (ID_FideAffidamento) {
                setFormData({ Type: "Set", Value: data.Dato });
                setCurrentStatus(data.Dato.ID_TipoFideAffidamentoEsito || Glob.Tipi_FAE_CreazioneAffidamento);
            } else {
                setFormData({ Type: "Set", Value: initialFormData });
                setCurrentStatus("");
            }
            setTypes(data.Tipi);
        }
    };

    const GetLimits = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/deroga/GetLimitiDeroga?ID_Deroga=${ID_FideAffidamento}&ID_TipoDerogaStato=${Glob.Tipi_DR_Approvata}`,
            OnRis: OnGetLimits,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetLimits = (sender: ChiamaWeb, data: Dati.CRisAPIDizionario<Dati.CTipoCampoDeroga>) => {
        if (!data.Errore) {
            const fields = data.Dati;
            const newLimits = { ...Limits };

            for (const field in fields) {
                const indicator = fields[field].Verso == ">" ? "MAX" : "MIN";

                switch (fields[field].Tipo) {
                    case "Importo":
                    case "Percentuale":
                        _LimitiDeroga[field + indicator] = Number(fields[field].Valore);
                        break;
                }

                if (fields[field].Verso == ">") {
                    if (newLimits[field + indicator] == undefined || _LimitiDeroga[field + indicator] > newLimits[field + indicator]) {
                        newLimits[field + indicator] = _LimitiDeroga[field + indicator];
                    }
                } else {
                    if (newLimits[field + indicator] == undefined || _LimitiDeroga[field + indicator] < newLimits[field + indicator]) {
                        newLimits[field + indicator] = _LimitiDeroga[field + indicator];
                    }
                }
            }

            setLimits(newLimits);
            SetLimitsOnLocalVariables();
            SetLimitsOnLimitsSOA();
        }
    };

    const SetLimitsOnLocalVariables = () => {
        const updatedLimits = { ...Limits };

        switch (FormData.ID_TipoFideAffidamento) {
            case Glob.Tipi_FA_NonProvvisorie:
                if (_LimitiDeroga["LimiteMassimoContraenteMAX"] == undefined) {
                    updatedLimits["LimiteMassimoContraenteMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (_LimitiDeroga["LimiteMassimoFideiussioneMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussioneMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (updatedLimits["LimiteMassimoFideiussioneAutonomiaPOSMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussioneAutonomiaPOSMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                break;
            case Glob.Tipi_FA_Provvisorie:
                if (_LimitiDeroga["LimiteMassimoContraenteMAX"] == undefined) {
                    updatedLimits["LimiteMassimoContraenteMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (_LimitiDeroga["LimiteMassimoFideiussioneMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussioneMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (updatedLimits["LimiteMassimoFideiussioneAutonomiaPOSMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussioneAutonomiaPOSMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                break;
            case Glob.Tipi_FA_Affidamento:
                if (_LimitiDeroga["LimiteMassimoContraente_NonProvvisorieMAX"] == undefined) {
                    updatedLimits["LimiteMassimoContraente_NonProvvisorieMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (_LimitiDeroga["LimiteMassimoFideiussione_NonProvvisorieMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussione_NonProvvisorieMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (_LimitiDeroga["LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorieMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussioneAutonomiaPOS_NonProvvisorieMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoNonProvvisorie);
                }
                if (_LimitiDeroga["LimiteMassimoContraente_ProvvisorieMAX"] == undefined) {
                    updatedLimits["LimiteMassimoContraente_ProvvisorieMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (_LimitiDeroga["LimiteMassimoFideiussione_ProvvisorieMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussione_ProvvisorieMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                if (updatedLimits["LimiteMassimoFideiussioneAutonomiaPOS_ProvvisorieMAX"] == undefined) {
                    updatedLimits["LimiteMassimoFideiussioneAutonomiaPOS_ProvvisorieMAX"] = Glob.GetLimite(Glob.Tipi_GL_AffidamentoProvvisorie);
                }
                break;
        }

        setLimits(updatedLimits);
    };

    const GetLimitsSOA = (): void => {
        const Param: CChiamaWebParametri = {
            URL: "/api/fideaffidamento/LimitiSOA",
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIDizionario<number>) => {
                if (!data.Errore) {
                    setLimitsSOA(data.Dati);
                }
            },
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const SetLimitsOnLimitsSOA = () => {
        const updatedLimits = { ...Limits };

        if (LimitsSOA != undefined && FormData.ID_TipoSOA) {
            let limitSOA = 0;
            if (LimitsSOA["LimiteSOA-Massimale-" + FormData.ID_TipoSOA] != undefined) {
                limitSOA = LimitsSOA["LimiteSOA-Massimale-" + FormData.ID_TipoSOA];
                if (limitSOA > 0 && updatedLimits["LimiteMassimoFideiussioneMAX"] > limitSOA) {
                    updatedLimits["LimiteMassimoFideiussioneMAX"] = limitSOA;
                }
                if (limitSOA > 0 && updatedLimits["LimiteMassimoFideiussione_ProvvisorieMAX"] > limitSOA) {
                    updatedLimits["LimiteMassimoFideiussione_ProvvisorieMAX"] = limitSOA;
                }
            }
            if (LimitsSOA["LimiteSOA-Affidamento-" + FormData.ID_TipoSOA + "-" + FormData.ID_TipoFideAffidamento] != undefined) {
                limitSOA = LimitsSOA["LimiteSOA-Affidamento-" + FormData.ID_TipoSOA + "-" + FormData.ID_TipoFideAffidamento];
                if (limitSOA > 0 && updatedLimits["LimiteMassimoContraenteMAX"] > limitSOA) {
                    updatedLimits["LimiteMassimoContraenteMAX"] = limitSOA;
                }
                if (limitSOA > 0 && updatedLimits["LimiteMassimoContraente_ProvvisorieMAX"] > limitSOA) {
                    updatedLimits["LimiteMassimoContraente_ProvvisorieMAX"] = limitSOA;
                }
            }

            setLimits(updatedLimits);
        }
    };

    const GetFormData = (): Dati.CIngrAPI<DatiFide.CDatiFideAffidamento> => {
        const data = new Dati.CIngrAPI<DatiFide.CDatiFideAffidamento>();
        data.Dato = FormData;

        return data;
    };

    const GetChangedStatusFormData = (newStatus: string): Dati.CIngrAPI<DatiFide.CDatiFideAffidamento> => {
        const data = GetFormData();

        data.Dato.ID_TipoFideAffidamentoEsito = newStatus;
        return data;
    };

    const GetRevisionData = (): Dati.CIngrAPI<DatiFide.CDatiFideAffidamento> => {
        const data = GetFormData();

        data.Dato.ID_TipoFideAffidamentoEsito = Glob.Tipi_FAE_Revisione;
        data.Dato.ListaFideAffidamentoApprovazioneJSON = "[]";
        return data;
    };

    const OnClickSave = (data: DatiFide.CRisAPIDatoTipi_FideAffidamento) => {
        if (data.Errore) {
            ShowDialog("ERRORE", Trad.Trad(data.ErrTesto), "error");
        } else {
            ShowDialog("AFFIDAMENTO", Trad.TradParam("Affidamento salvato correttamente con ID: {1-S}", [data.ID_Chiave]), "success");
            setFormData({ Type: "OnChangeFromValue", Name: "ListaFideAffidamentoApprovazioneJSON", Value: data.MessaggioDati });
            history.push(`/anagrafica/${ID_Anag}/fideaffidamento/${data.ID_Chiave}`);
        }
    };


    return (
        <form noValidate autoComplete="off">
            {ID_FideAffidamento == FormData.ID_FideAffidamento && (
                <_ExposureLimitFormContent
                    Data={FormData}
                    CurrentStatus={CurrentStatus}
                    Limits={Limits}
                    Types={Types}
                    OnChange={(e, val) => setFormData({
                        Type: "OnChangeFromHybrid",
                        NameEvent: val != null && val != undefined ? e : Object.assign({}, e),
                        Value: val
                    })}
                    OnChangeDerogation={OnChangeDerogation}
                />
            )}
            <Grid container spacing={4} justify="flex-end">
                {editingRights && (
                    <Grid item>
                        {CurrentStatus != Glob.Tipi_FAE_Sottoscritto ? (
                            <_ButtonAPI Default Attivo Testo={Trad.Trad("Salva")} URL="/api/fideaffidamento/"
                                        OnInvio={GetFormData} OnClick={OnClickSave} OnErrore={OnApiError}/>
                        ) : (
                            <_ButtonAPI Default Attivo Testo={Trad.Trad("Revisione affidamento")}
                                        URL="/api/fideaffidamento/" OnInvio={GetRevisionData} OnClick={OnClickSave}
                                        OnErrore={OnApiError}/>
                        )}
                    </Grid>
                )}
               <_ChangeStatusButtons
                    Statuses={Types["FideAffidamentoEsito"]}
                    CurrentStatus={CurrentStatus}
                    GetFormData={GetChangedStatusFormData}
                    OnChangeState={(data: DatiFide.CRisAPIDatoTipi_FideAffidamento) => {
                        OnClickSave(data);
                    }}
                    OnApiError={OnApiError}
                />
                {!!ID_FideAffidamento && Object.keys(DerogationFieldsList).length > 0 && <_Derogation Data={DerogationFieldsList} Id={ID_FideAffidamento} Type={Glob.Tipi_DT_Fideiussione} />}
            </Grid>
        </form>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ExposureLimit/ExposureLimitForm.tsx